import { ICreateImportTemplate, IImportTemplate } from '../types'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class ImportTemplateService {
  public async getAll() {
    const resp: any = await serverApi.get(Paths.importTemplate.base)
    return resp.data
  }

  public async fetchById(id: string) {
    const resp: any = await serverApi.get(Paths.importTemplate.byId, {
      params: { id }
    })
    return resp.data
  }

  public async createImportTemplate(importTemplate: ICreateImportTemplate) {
    try {
      const resp: any = await serverApi.post(Paths.importTemplate.create, importTemplate)
      return resp.data
    } catch (e) {
      throw e.data
    }
  }

  public async updateImportTemplate(importTemplate: IImportTemplate) {
    try {
      const resp: any = await serverApi.put(Paths.importTemplate.update, importTemplate)
      return resp.data
    } catch (e) {
      throw e.data
    }
  }

  public async deleteImportTemplate(id: string) {
    try {
      const resp: any = await serverApi.delete(Paths.importTemplate.delete.replace(':id', id))
      return resp.data
    } catch (e) {
      throw e.data
    }
  }
}

const importTemplateService = new ImportTemplateService()

export { importTemplateService }



// WEBPACK FOOTER //
// ./src/services/Import.ts